function getKeys(dev) {
  if (!dev) {
    // PRODUÇÃO
    return {
      apiKey: "AIzaSyB55oZmjL0lm3937dJ4XNDlAqe_qxw4nMA",
      authDomain: "photonow-app.firebaseapp.com",
      databaseURL: "https://photonow-app-default-rtdb.firebaseio.com",
      projectId: "photonow-app",
      storageBucket: "photonow-app.appspot.com",
      messagingSenderId: "411040390426",
      appId: "1:411040390426:web:2aff0e33f3692ee8b5e0a3",
    };
  } else {
    // DEV
    return {
      apiKey: "AIzaSyC14xfZCwILN6-7XLRh0i3NSDUrL7sP8wk",
      authDomain: "cabine-teste.firebaseapp.com",
      projectId: "cabine-teste",
      storageBucket: "cabine-teste.appspot.com",
      messagingSenderId: "247253049193",
      appId: "1:247253049193:web:dea312fb8950abf67a27f8",
    };
  }
}

let env_dev = document.location.hostname == "mobile-teste-cabine.web.app" ||
    document.location.hostname == "localhost";

export const FUNCTIONS_URL = env_dev
  ? "https://us-central1-cabine-teste.cloudfunctions.net/"
  : "https://us-central1-photonow-app.cloudfunctions.net/";

export const FIREBASE_CHAVE_SERVER = getKeys(env_dev);

export const RECAPTCHA_ENTERPRISE_KEY = env_dev
  ? "6LcrOActAAAAANCf34x9M1cxNgdhxkKllJFpi2fY"
  : "6LcWXwctAAAAALR2ORrkT7priAG-6GqbTS0ehByC";

// Debug token do App Check — usado só em desenvolvimento
// Defina VUE_APP_APPCHECK_DEBUG_TOKEN no arquivo .env.local (não commitado)
export const APPCHECK_DEBUG_TOKEN = env_dev
  ? (process.env.VUE_APP_APPCHECK_DEBUG_TOKEN || null)
  : null;